import { SGeneralForms, SLocalSelected, SLocalTreeSelected, SSegmentedTabs } from 'shj-components'
import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react'
import { getGeneralList, getProductEnums, getUpdateNodes } from '@/services/product.ts'
import { Button, Checkbox, Input, Radio, Select, Spin, Tooltip, TreeSelect } from 'antd'
import { useSetState, useUpdateEffect } from 'ahooks'
import { getRoleList, getRolePage } from '@/services/homeService.ts'
import { getChildrenDicts } from '@/services'
import { cloneDeep } from 'lodash-es'
import { replaceRule } from '@/utils/data.ts'
import RulesModal from '@/pages/baseProduct/components/RuleModal/RulesModal'
import _ from 'lodash'
import { QuestionCircleOutlined } from '@ant-design/icons'

type IProps = {
  fn: () => void
  companyList: any[]
  setSubmitLoading: (v: boolean) => void
  baseInfo: any // 基础信息
  record: any // 当前数据
  dataSource: any[] // 所有数据
  isSubtract: boolean //
}

export const AddOrEditGeneral = forwardRef((props: IProps, ref) => {
  const { record, companyList, dataSource = [] } = props
  const formRef = useRef()
  const [state, setState] = useSetState<any>({
    roleList: [],
    roleListEnum: [],
    copyDisabled: false,
    loading: false,
    dtlName: '',
    updateNodesList: [], // 更新节点
  })
  const [optionList, setOptionList] = useState([{ id: '0', name: '通用' }, ...companyList])
  const [ruleModal, setRuleModal] = useSetState({
    open: false,
    mode: 'modal',
    budgetQuantityRule: '',
    changeLevelScope: '',
    key: '',
  })
  useEffect(() => {
    onFormRef()?.resetFields()
    setRuleModal({ changeLevelScope: '',budgetQuantityRule:'' })
    const changeLevelScope = JSON.parse(record.changeLevelScope || null)?.rule || ''
    const budgetQuantityRule = JSON.parse(record.budgetQuantityRule || null)?.rule || ''
    shopsControl(record.shops)
    onFormRef()?.setFieldsValue({
      ...record,
      parentId: record.parentId == 0 ? null : record.parentId,
      shops: record.shops,
      roles: record.roles,
    })
    setRuleModal({ changeLevelScope,budgetQuantityRule})
    if (!record.roleFilterType && state.roleListEnum.length) {
      onFormRef()?.setFieldValue('roleFilterType', state.roleListEnum[0]?.value)
    }
    // 添加更新节点
    if (record.updateNodesList?.length) {
      setState({
        updateNodesList: record.updateNodesList,
      })
    } else {
      getUpdateNodes().then((res: any) => {
        setState({
          updateNodesList:
            res?.map(item => {
              return {
                ...item,
                checked: record.updateNodes ? record.updateNodes?.includes(item.node) : false,
              }
            }) || [],
        })
      })
    }
  }, [record, state.roleListEnum])

  const dealTree = (data, res = []) => {
    data.forEach(item => {
      if (item.busType === 'PRD_CATE' || item.busType === 'PRD_PROJECT') {
        res.push(item)
        if (item.children?.length) {
          item.children = dealTree(item.children)
        }
      }
    })
    return res
  }

  const tree = useMemo(() => {
    return dealTree(cloneDeep(dataSource))
  }, [dataSource])

  const onFormRef = () => {
    const { onFormRef } = formRef.current || {}
    return onFormRef?.()
  }
  const getOptions = async () => {
    setState({ loading: true })
    try {
      const roleList = await getProductEnums('com.shj.saas.plus.product.enums.RoleFilterTypeEnum')
      const filterRoleList = await getRoleList({ data: { enabled: true } })
      const generalList = await getGeneralList({ enabled: true })
      const space: any = await getChildrenDicts(['spaceKey'])
      setState({
        roleList: roleList.map(item => ({ label: item.description, value: item.key })),
        generalList,
        filterRoleList,
        loading: false,
      })
      return Promise.resolve({ generalList, spaceList: space[0]?.children, roleList })
    } catch (e) {
      setState({ loading: false })
    }
  }

  const getShopArr = codeArr => {
    return optionList?.reduce((res, item) => {
      if (codeArr.includes(item.id)) res.push({ id: item.id, companyName: item.name })
      return res
    }, [])
  }
  const shopsControl = (value: any) => {
    let newOption: any = _.cloneDeep(optionList)
    if (value?.length) {
      if (value.includes('0')) {
        newOption = newOption.map((item: any) => {
          return {
            ...item,
            disabled: item.id !== '0',
          }
        })
      } else {
        newOption = newOption.map((item: any) => {
          return {
            ...item,
            disabled: item.id === '0',
          }
        })
      }
    } else {
      newOption = newOption.map((item: any) => {
        return {
          ...item,
          disabled: false,
        }
      })
    }
    setOptionList(newOption)
  }
  const onFinish = (): Promise<any> => {
    return new Promise(resolve => {
      onFormRef()
        ?.validateFields()
        .then(values => {
          props.setSubmitLoading?.(true)
          const shopList = values.shops ? getShopArr(values.shops) : []
          const object = state.generalList.find(item => item.id === values.busId)
          const obj = {
            ...values,
            id: record.id,
            parentId: values.parentId,
            oldParentId: record.parentId || '0',
            level: record.level || 0,
            shopList: shopList,
            shops: values.shops,
            dtlName: object.itemName,
            busType: 'PRD_GEN_ITEM',
            busTypeName: '通项',
            busId: values.busId,
            object,
            roleFilterType: values.roleFilterType,
            roleFilterValue: values.roleFilterValue,
            changeLevelScope: JSON.stringify({ rule: ruleModal.changeLevelScope }),
            budgetQuantityRule: JSON.stringify({ rule: ruleModal.budgetQuantityRule }),
            updateNodesList: state?.updateNodesList, // 更新节点
            updateNodes: state?.updateNodesList
              .filter(item => item.checked)
              ?.map(item => item.node),
          }
          console.log(obj, 'save')
          resolve(obj)
        })
    })
  }
  useImperativeHandle(ref, () => {
    return {
      onFinish,
    }
  }, [onFinish])
  // 更新节点
  const onChangeTime = e => {
    const newList = state.updateNodesList
    console.log(e)
    console.log(newList)
    newList.forEach((item: any) => {
      if (e.target.value === 'BEFORE_START_WORK' && e.target.checked) {
        item.checked = true
      } else if (e.target.value === 'BEFORE_SIGN' && !e.target.checked) {
        item.checked = false
      } else if (item.node === e.target.value) {
        item.checked = e.target.checked
      }
    })
    setState({
      updateNodesList: [...newList],
    })
    onFormRef()?.setFieldsValue({
      updateNodesList: [...newList],
    })
  }

  const onOpenRule = key => {
    setRuleModal({ open: true, key })
  }

  return (
    <>
      <Spin spinning={state.loading}>
        <SGeneralForms
          ref={formRef}
          isHideGobackBtn={true}
          initialValues={{
            isMust: true,
            isCopy: true,
            isShowOrder: true,
            isSubtract: true,
            // standardFlag: true,
            roleFilterType: 'NONE_FILTER',
          }}
          httpOptionsFn={getOptions}
          layout="vertical"
          titleMode={'edit'}
          configs={[
            {
              title: '基础信息',
              formItem: [
                {
                  name: 'parentId',
                  label: '所属上级',
                  spanCol: 24,
                  children: (
                    <TreeSelect
                      treeData={tree}
                      placeholder={'请选择所属上级'}
                      fieldNames={{ label: 'name', value: 'id' }}
                      treeTitleRender={node => node?.dtlName}
                    />
                  ),
                },
                {
                  name: 'busId',
                  label: '通项',
                  required: true,
                  rules: [{ required: true, message: '通项不能为空' }],
                  spanCol: 24,
                  data: 'generalList',
                  type: 'select',
                  comConfig: {
                    fieldNames: { label: 'itemName', value: 'id' },
                    onChange: (_, o) => setState({ dtlName: o.itemName }),
                  },
                },
              ],
            },
            {
              title: '打包配置',
              formItem: [
                {
                  name: 'isMust',
                  label: '是否必选',
                  spanCol: 24,
                  type: 'switch',
                  comConfig: {
                    checkedChildren: '是',
                    unCheckedChildren: '否',
                  },
                },
                //是否标配隐藏
                // {
                //   name: 'standardFlag',
                //   label: '是否标配',
                //   spanCol: 24,
                //   type: 'switch',
                //   comConfig: {
                //     checkedChildren: '是',
                //     unCheckedChildren: '否',
                //   },
                // },
                {
                  label: '升降级范围',
                  spanCol: 24,
                  isDeps: true,
                  deps: () => props.baseInfo?.allowDownLevel || props.baseInfo?.allowUpLevel,
                  children: (
                    <div>
                      <Button onClick={() => onOpenRule('changeLevelScope')}>编辑规则</Button>
                      {ruleModal?.changeLevelScope && (
                        <Input.TextArea
                          autoSize={{ minRows: 1, maxRows: 4 }}
                          disabled
                          style={{ marginTop: 6 }}
                          value={replaceRule(ruleModal.changeLevelScope)}
                        />
                      )}
                    </div>
                  ),
                },
                {
                  name: 'isSubtract',
                  label: '是否可减项',
                  spanCol: 24,
                  type: 'switch',
                  // isDeps: true,
                  // deps: form => form.getFieldValue('isMust') && props.baseInfo.isSubtract,
                  comConfig: {
                    checkedChildren: '是',
                    unCheckedChildren: '否',
                  },
                },
                {
                  name: 'isCopy',
                  label: '是否允许复制',
                  spanCol: 24,
                  type: 'switch',
                  comConfig: {
                    checkedChildren: '是',
                    unCheckedChildren: '否',
                  },
                },
                {
                  label: '预算量',
                  spanCol: 24,
                  children: (
                      <div>
                        <Button onClick={() => onOpenRule('budgetQuantityRule')}>编辑规则</Button>
                        {ruleModal?.budgetQuantityRule && (
                            <Input.TextArea
                                autoSize={{ minRows: 1, maxRows: 4 }}
                                disabled
                                style={{ marginTop: 6 }}
                                value={replaceRule(ruleModal.budgetQuantityRule)}
                            />
                        )}
                      </div>
                  ),
                },
              ],
            },
            {
              title: '显示配置',
              formItem: [
                {
                  name: 'isShowOrder',
                  label: '下单时是否显示',
                  spanCol: 24,
                  type: 'switch',
                  comConfig: {
                    disabled: state.copyDisabled,
                    checkedChildren: '是',
                    unCheckedChildren: '否',
                  },
                },

                {
                  name: 'roleFilterType',
                  label: '系统角色过滤',
                  spanCol: 24,
                  children: <Radio.Group options={state.roleList} />,
                },
                {
                  name: 'roleFilterValue',
                  label: '过滤角色',
                  spanCol: 24,
                  required: true,
                  rules: [{ required: true, message: '过滤角色不能为空' }],
                  isDeps: true,
                  deps: form => form.getFieldValue('roleFilterType') !== 'NONE_FILTER',
                  children: (
                    <SLocalSelected
                      optionsData={state.filterRoleList}
                      placeholder={'输入搜索过滤角色'}
                      configData={{ label: 'name', value: 'id' }}
                      mode={'multiple'}
                      onChange={(_, o) => {
                        setState({
                          selectedRoleList: o.map(item => ({
                            id: item.value,
                            name: item.children,
                          })),
                        })
                      }}
                    />
                  ),
                },
              ],
            },
            {
              title: '适用渠道',
              formItem: [
                {
                  name: 'shops',
                  label: '适用门店',
                  spanCol: 24,
                  children: (
                    <Select
                      optionFilterProp={'name'}
                      placeholder={'请选择适用门店'}
                      mode={'multiple'}
                      fieldNames={{ label: 'name', value: 'id' }}
                      onChange={(value, option) => {
                        shopsControl(value)
                      }}
                      options={optionList}
                    />
                  ),
                },
              ],
            },
            {
              title: '更新配置',
              formItem: [
                {
                  name: 'updateNodes',
                  label: (
                    <>
                      <Tooltip title="该项数据新增或编辑后，对订单商品哪些节点的报价生效。注意：默认所有新增报价均会生效。">
                        <span>
                          <QuestionCircleOutlined /> 更新节点
                        </span>
                      </Tooltip>
                    </>
                  ),
                  spanCol: 24,
                  children: (
                    <>
                      {state.updateNodesList?.map((item, index) => {
                        return (
                          <Checkbox
                            key={index}
                            checked={item.checked}
                            value={item.node}
                            onChange={onChangeTime}
                          >
                            {item.name}
                          </Checkbox>
                        )
                      })}
                    </>
                  ),
                },
              ],
            },
          ]}
        />

        {ruleModal.open && (
            <RulesModal
                modalProps={{ ...ruleModal, value: ruleModal[ruleModal.key] || '' }}
                onCancel={() => setRuleModal({ open: false })}
                type={ruleModal.key === 'budgetQuantityRule' ? 'generalBudgetItem' : 'productFilterRule'}
                onOk={(value: string) => setRuleModal({ [ruleModal.key]: value })}
            />
        )}
      </Spin>
    </>
  )
})
